import { action, observable } from "mobx"
import fileService from "@services/common/fileService"
import { FileModel } from "@models/File"
import AppConsts from "@lib/appconst"
const { documentType } = AppConsts
class FileStore {
  @observable currentFiles: FileModel[] = []

  @action
  async getFiles(id?) {
    this.currentFiles = []
    if (!id) {
      return
    }
    const result = await fileService.get(id)
    // Không filter hình ảnh để hiển thị avatar
    this.currentFiles = result
    return result
  }
  @action
  async downloadDocument(key?) {
    if (!key) {
      return
    }
    await fileService.downloadDocument(key)
  }
  @action
  async getDocumentDownloadUrl(params) {
    return await fileService.getDocumentDownloadUrl(params)
  }
  async getDocumentsByRequestId(id?) {
    this.currentFiles = []
    if (!id) {
      return
    }
    const result = await fileService.getDocumentsByRequestId(id)
    result.filter(
      (item) =>
        item.documentTypeId !== documentType.image &&
        item.documentTypeId !== documentType.logo
    )
    return result
  }
  @action
  async emtyCurrentFiles() {
    this.currentFiles = []
  }
  @action
  async delete(guid) {
    await fileService.delete(guid)
    this.currentFiles = this.currentFiles.filter((item) => item.uid !== guid)
  }

  @action
  async update(file) {
    file.isMainPhoto = false
    await fileService.update(file)
  }

  @action
  async updateMainPhoto(moduleId, parentId, fileId) {
    await fileService.updateMainPhoto(moduleId, parentId, fileId)
  }
  @action
  async uploadDocumentWithModuleName(files, dataModel) {
    await fileService.uploadDocumentWithModuleName(files, dataModel)
  }
}

export default FileStore
